/**
 * @export
 * @enum {string}
 */
export var RemedyTypeEnum;
(function (RemedyTypeEnum) {
    RemedyTypeEnum["Indeterminate"] = "indeterminate";
    RemedyTypeEnum["Manual"] = "manual";
    RemedyTypeEnum["Automated"] = "automated";
    RemedyTypeEnum["RuleResultMessage"] = "rule_result_message";
    RemedyTypeEnum["Terraform"] = "terraform";
    RemedyTypeEnum["Cloudformation"] = "cloudformation";
    RemedyTypeEnum["Cli"] = "cli";
    RemedyTypeEnum["Kubernetes"] = "kubernetes";
    RemedyTypeEnum["Arm"] = "arm";
})(RemedyTypeEnum || (RemedyTypeEnum = {}));
export var ClassTypeDef;
(function (ClassTypeDef) {
    ClassTypeDef["RuleCategory"] = "rule-category";
    ClassTypeDef["Compliance"] = "compliance";
    ClassTypeDef["Weakness"] = "weakness";
})(ClassTypeDef || (ClassTypeDef = {}));
export var ProblemTypeDef;
(function (ProblemTypeDef) {
    ProblemTypeDef["Rule"] = "rule";
    ProblemTypeDef["Vulnerability"] = "vulnerability";
})(ProblemTypeDef || (ProblemTypeDef = {}));
export var ResolutionTypeDef;
(function (ResolutionTypeDef) {
    ResolutionTypeDef["Disappeared"] = "disappeared";
    ResolutionTypeDef["Fixed"] = "fixed";
})(ResolutionTypeDef || (ResolutionTypeDef = {}));
/**
 * @export
 * @enum {string}
 */
export var SeverityLevelEnum;
(function (SeverityLevelEnum) {
    SeverityLevelEnum["Info"] = "info";
    SeverityLevelEnum["Low"] = "low";
    SeverityLevelEnum["Medium"] = "medium";
    SeverityLevelEnum["High"] = "high";
    SeverityLevelEnum["Critical"] = "critical";
})(SeverityLevelEnum || (SeverityLevelEnum = {}));
export var TypeDef;
(function (TypeDef) {
    TypeDef["PackageVulnerability"] = "package_vulnerability";
    TypeDef["License"] = "license";
    TypeDef["Cloud"] = "cloud";
    TypeDef["Code"] = "code";
    TypeDef["Custom"] = "custom";
    TypeDef["Config"] = "config";
})(TypeDef || (TypeDef = {}));
/**
 * @export
 * @enum {string}
 */
export var IssueAttributesEffectiveSeverityLevelEnum;
(function (IssueAttributesEffectiveSeverityLevelEnum) {
    IssueAttributesEffectiveSeverityLevelEnum["Info"] = "info";
    IssueAttributesEffectiveSeverityLevelEnum["Low"] = "low";
    IssueAttributesEffectiveSeverityLevelEnum["Medium"] = "medium";
    IssueAttributesEffectiveSeverityLevelEnum["High"] = "high";
    IssueAttributesEffectiveSeverityLevelEnum["Critical"] = "critical";
})(IssueAttributesEffectiveSeverityLevelEnum || (IssueAttributesEffectiveSeverityLevelEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var IssueAttributesStatusEnum;
(function (IssueAttributesStatusEnum) {
    IssueAttributesStatusEnum["Open"] = "open";
    IssueAttributesStatusEnum["Resolved"] = "resolved";
})(IssueAttributesStatusEnum || (IssueAttributesStatusEnum = {}));
export var ScanItemType;
(function (ScanItemType) {
    ScanItemType["Project"] = "project";
    ScanItemType["Environment"] = "environment";
})(ScanItemType || (ScanItemType = {}));
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["Organization"] = "organization";
})(OrganizationType || (OrganizationType = {}));
export var IgnoreType;
(function (IgnoreType) {
    IgnoreType["Ignore"] = "ignore";
})(IgnoreType || (IgnoreType = {}));
export var PolicyType;
(function (PolicyType) {
    PolicyType["Policy"] = "policy";
})(PolicyType || (PolicyType = {}));
export var TestExecutionType;
(function (TestExecutionType) {
    TestExecutionType["TestWorkflowExecution"] = "test-workflow-execution";
    TestExecutionType["CustomExecution"] = "custom-execution";
})(TestExecutionType || (TestExecutionType = {}));
export var IssueType;
(function (IssueType) {
    IssueType["Issue"] = "issue";
})(IssueType || (IssueType = {}));
//# sourceMappingURL=unifiedIssuesTypes.js.map